var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Radio',{model:{value:(_vm.selectedNew),callback:function ($$v) {_vm.selectedNew=$$v},expression:"selectedNew"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }